import ClassicElegance from './qr/classic_elegance/ClassicElegance';
import ModernChic from './qr/modern_chic/ModernChic';
import MidnightLuxe from './qr/midnight_luxe/MidnightLuxe';
import DineStackClassic from './qr/dine_stack_classic/DineStackClassic';
import MenuExplorer from './qr/menu_explorer/MenuExplorer';
import NeonNectar from './qr/neon_nectar/NeonNectar';
import BohoBliss from './qr/boho_bliss/BohoBliss';
import ComicCrunch from './qr/comic_crunch/ComicCrunch';
import CosmicCantina from './qr/cosmic_cantina/CosmicCantina';
import ClassicPrint from './pdf/classic_print/ClassicPrint';
import ModernMinimalist from './pdf/modern_minimalist/ModernMinimalist';
import RoyalGold from './pdf/royal_gold/RoyalGold';
import GardenFresh from './pdf/garden_fresh/GardenFresh';
import RusticWood from './pdf/rustic_wood/RusticWood';
import UrbanPop from './pdf/urban_pop/UrbanPop';
import GoanFiesta from './pdf/goan_fiesta/GoanFiesta';
import AzureAzulejos from './pdf/azure_azulejos/AzureAzulejos';
import TropicalSpice from './pdf/tropical_spice/TropicalSpice';

// Registry mapping template names (from API) to React Components
const templateRegistry = {
    'Classic Elegance': ClassicElegance,
    'Modern Chic': ModernChic,
    'Midnight Luxe': MidnightLuxe,
    'DineStack Classic': DineStackClassic,
    'Menu Explorer': MenuExplorer,
    'Neon Nectar': NeonNectar,
    'Boho Bliss': BohoBliss,
    'Comic Crunch': ComicCrunch,
    'Cosmic Cantina': CosmicCantina,
    'Classic Print': ClassicPrint,
    'Modern Minimalist': ModernMinimalist,
    'Royal Gold': RoyalGold,
    'Garden Fresh': GardenFresh,
    'Rustic Wood': RusticWood,
    'Urban Pop': UrbanPop,
    'Goan Fiesta': GoanFiesta,
    'Azure Azulejos': AzureAzulejos,
    'Tropical Spice': TropicalSpice,
    // Add more templates here
};

export const getTemplateComponent = (templateName) => {
    return templateRegistry[templateName] || ClassicElegance; // Fallback to default
};

export const getPDFTemplateComponent = (templateName) => {
    return templateRegistry[templateName] || ClassicPrint; // Fallback to default PDF template
};

export default templateRegistry;
